import React, { useState, useRef, useEffect } from 'react';

import { Accordion, AccordionTab } from 'primereact/accordion';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { locale, addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

import { CALENDARIO_ES_MX } from '../../../servicios/Constantes';
import { ServicioObjetos } from '../../../servicios/ServicioObjetos';
import { ServicioArchivos } from '../../../servicios/ServicioArchivos';
import { ServicioHttp } from '../../../servicios/ServicioHttp';


export const Reportes = () => {
    addLocale('es', CALENDARIO_ES_MX);
    locale('es');

    const [busqueda, setBusqueda] = useState({});
    const toast = useRef(null);
    const [admin, setAdmin] = useState(false);
    const [entidades, setEntidades] = useState({});

    useEffect(() => {
        verificarAdministrador();

    }, [])

    const verificarAdministrador = () => {
        ServicioHttp.consumirPostHttp('perfil/validar_usuario.json').then(response => {
            if (response.data.error) {
                consultaEntidades();
                setAdmin(response.data.error);

            }
        }).catch(error => {

        });
    }

    const consultaEntidades = () => {
        let paginacion_entidad = {
            registrosPorPagina: 10000,
            numeroPagina: 0,
            restriccionesDinamicas: [],
            datos: []
        };
        ServicioHttp.consumirPostHttp('entidad/consulta.json', paginacion_entidad).then(response => {
            console.log(response.data.objeto.datos);
            setEntidades(response.data.objeto.datos);
        }).catch(error => {

        });
    }

    const handleChange = e => {
        const { name, value } = e.target;
        setBusqueda(valoresUsuarioPrevios => ({
            ...valoresUsuarioPrevios,
            [name]: value
        }));
    };


    const descargarReporteMes = () => {
        try {
            let entidad = null
            if (ServicioObjetos.esObjetoVacio(busqueda.fechaCreacion))
                throw new Error('Fecha Mes requerida');

            if (admin && ServicioObjetos.esObjetoVacio(busqueda.entidad))
                throw new Error('Entidad requerida');

            if (admin && !ServicioObjetos.esObjetoVacio(busqueda.entidad))
                entidad = { id: busqueda.entidad.id };

            ServicioArchivos.descargaArchivo('reporte/descarga_excel_mes.json', { fechaCreacion: busqueda.fechaCreacion.getTime(), tcEntidad: entidad });
        } catch (error) {
            toast.current.show({ severity: 'error', summary: '', detail: error.message, life: 8000 });
        }
    }


    const descargarPorFechaCreacion = () => {
        try {
            let entidad = null
            if (ServicioObjetos.esObjetoVacio(busqueda.fechaPago))
                throw new Error('Fecha de Pago requerida');
            if (admin && ServicioObjetos.esObjetoVacio(busqueda.entidad))
                throw new Error('Entidad requerida');
            if (admin && !ServicioObjetos.esObjetoVacio(busqueda.entidad))
                entidad = { id: busqueda.entidad.id };

            ServicioArchivos.descargaArchivo('reporte/descarga_excel_mes.json', { fechaPago: busqueda.fechaPago.getTime(), tcEntidad: entidad });
        } catch (error) {
            toast.current.show({ severity: 'error', summary: '', detail: error.message, life: 8000 });
        }
    }


    return (
        <>
            <Toast ref={toast} />
            <div className="grid list-demo">
                <div className="col-12">
                    <div className="card p-fluid">
                        <h5>Reportes Recibo Nómina</h5>
                        <Accordion className="accordion-custom">
                            <AccordionTab header={<React.Fragment><i className="pi pi-calendar"></i><span>Descarga Excel por Mes</span></React.Fragment>}>
                                <div className="p-fluid formgrid grid">
                                    <div className="field col-12 md:col-6">
                                        <label htmlFor="nombre">* Selecciona el Mes:</label>
                                        <Calendar appendTo={document.body} id="fechaCreacion" name="fechaCreacion" value={busqueda.fechaCreacion || ""} onChange={handleChange} view="month" dateFormat="mm/yy" yearNavigator yearRange="2022:2030" />
                                    </div>
                                    {admin ?
                                        <>
                                            <div className="field col-12 md:col-6">
                                                <label htmlFor="uuid">Entidad:</label>
                                                <Dropdown name="entidad" value={busqueda.entidad} options={entidades} optionLabel="descripcion" onChange={handleChange} placeholder="Seleciona Entidad" />
                                            </div>

                                        </> : <div className="field col-12 md:col-6">
                                            <label htmlFor="uuid"></label>
                                            <label htmlFor="uuid"></label>
                                        </div>}

                                    <div className="col-12 md:col-6">
                                        <Button label="Descarga Reporte" icon="pi pi-search" onClick={descargarReporteMes} />
                                    </div>
                                </div>




                            </AccordionTab>
                            <AccordionTab header={<React.Fragment><i className="pi pi-calendar"></i><span>Descarga Excel por Fecha de Pago</span></React.Fragment>}>
                                <div className="p-fluid formgrid grid">
                                    <div className="field col-12 md:col-6">
                                        <label htmlFor="nombre">* Selecciona Fecha de Pago:</label>
                                        <Calendar appendTo={document.body} id="fechaPago" name="fechaPago" value={busqueda.fechaPago || ""} onChange={handleChange} />
                                    </div>
                                    {admin ?
                                        <>
                                            <div className="field col-12 md:col-6">
                                                <label htmlFor="uuid">Entidad:</label>
                                                <Dropdown name="entidad" value={busqueda.entidad} options={entidades} optionLabel="descripcion" onChange={handleChange} placeholder="Seleciona Entidad" />
                                            </div>

                                        </> : <div className="field col-12 md:col-6">
                                            <label htmlFor="uuid"></label>
                                            <label htmlFor="uuid"></label>
                                        </div>}

                                    <div className="field col-12 md:col-6">
                                        <Button label="Descarga Reporte" icon="pi pi-search" onClick={descargarPorFechaCreacion} />
                                    </div>

                                </div>

                            </AccordionTab>
                        </Accordion>
                    </div>
                </div>
            </div>


        </>)
}